module.exports = __webpack_public_path__ + "static/media/mock-aero1.45e5d1cb.png";